import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { C } from '../theme';

const NAV = [
  { path: '/installer/dashboard', label: 'Dashboard', icon: '📊' },
  { path: '/installer/get-device', label: 'Get Device', icon: '📷' },
  { path: '/installer/mapping', label: 'Mapping', icon: '🗺️' },
];

export default function InstallerLayout({ children, title }) {
  const { user, logout } = useAuth();
  const navigate  = useNavigate();
  const location  = useLocation();

  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', fontFamily: "'Segoe UI', sans-serif" }}>

      {/* Sidebar */}
      <aside style={{
        width: '200px', minWidth: '200px',
        background: C.sidebar,
        display: 'flex', flexDirection: 'column',
        position: 'sticky', top: 0, height: '100vh',
      }}>
        {/* Brand */}
        <div style={{ padding: '22px 20px', borderBottom: `1px solid rgba(255,255,255,0.08)` }}>
          <div style={{ fontSize: '17px', fontWeight: 800, color: C.primary, letterSpacing: '1px' }}>🐝 HIVE ERP</div>
          <div style={{ fontSize: '10px', color: 'rgba(255,255,255,0.3)', letterSpacing: '2px', marginTop: '2px' }}>INSTALLER PORTAL</div>
        </div>

        {/* Nav */}
        <nav style={{ flex: 1, padding: '10px 0' }}>
          {NAV.map(item => {
            const active = location.pathname === item.path;
            return (
              <div
                key={item.path}
                onClick={() => navigate(item.path)}
                style={{
                  display: 'flex', alignItems: 'center', gap: '10px',
                  padding: '12px 20px', cursor: 'pointer', fontSize: '13px',
                  fontWeight: active ? 600 : 400,
                  color: active ? C.primary : 'rgba(255,255,255,0.6)',
                  background: active ? 'rgba(245,166,35,0.12)' : 'transparent',
                  borderRight: active ? `3px solid ${C.primary}` : '3px solid transparent',
                  transition: 'all 0.15s',
                }}
                onMouseEnter={e => { if (!active) e.currentTarget.style.background = 'rgba(255,255,255,0.05)'; }}
                onMouseLeave={e => { if (!active) e.currentTarget.style.background = 'transparent'; }}
              >
                <span style={{ fontSize: '16px' }}>{item.icon}</span>
                <span>{item.label}</span>
              </div>
            );
          })}
        </nav>

        {/* User strip */}
        <div style={{ padding: '14px 16px', borderTop: `1px solid rgba(255,255,255,0.08)` }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
            <div style={{
              width: '34px', height: '34px', borderRadius: '50%',
              background: `linear-gradient(135deg, #8B5CF6, #6D28D9)`,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontWeight: 700, color: '#fff', fontSize: '13px', flexShrink: 0,
            }}>
              {(user?.username || 'I')[0].toUpperCase()}
            </div>
            <div>
              <div style={{ fontSize: '12px', fontWeight: 600, color: '#fff' }}>{user?.full_name || user?.username}</div>
              <div style={{ fontSize: '10px', color: 'rgba(255,255,255,0.35)', textTransform: 'capitalize' }}>Installer</div>
            </div>
          </div>
          <button onClick={handleLogout} style={{
            width: '100%', padding: '7px 10px',
            background: 'rgba(255,255,255,0.06)', color: 'rgba(255,255,255,0.5)',
            border: '1px solid rgba(255,255,255,0.1)', borderRadius: '6px',
            cursor: 'pointer', fontSize: '11px', fontWeight: 500,
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px',
          }}>
            <span>⏻</span> Sign Out
          </button>
        </div>
      </aside>

      {/* Content */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', background: C.primaryBg, minWidth: 0 }}>
        {/* Topbar */}
        <header style={{
          background: C.white, borderBottom: `1px solid ${C.border}`,
          padding: '0 28px', height: '56px',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          position: 'sticky', top: 0, zIndex: 50,
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div style={{ width: '3px', height: '20px', background: '#8B5CF6', borderRadius: '2px' }} />
            <h1 style={{ margin: 0, fontSize: '17px', fontWeight: 700, color: C.textMain }}>{title}</h1>
          </div>
          <div style={{ fontSize: '12px', color: C.textSub }}>
            {(() => { const d = new Date(); return `${String(d.getDate()).padStart(2,'0')}-${String(d.getMonth()+1).padStart(2,'0')}-${d.getFullYear()}`; })()}
          </div>
        </header>

        <main style={{ flex: 1, padding: '24px 28px', overflow: 'auto' }}>
          {children}
        </main>
      </div>
    </div>
  );
}
